function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
  id: "a9920bde-2c0e-4686-88a5-5d3c54e18443",
  x: 54.4,
  y: 64.75,
  width: 33.73,
  height: 29.27,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  className: "e9f6f297-f1df-4f88-9e9d-e5bc97273b66",
  d: "M87.56 85.39A17.87 17.87 0 1157 66.9c5.09-8.44 35.67 10.1 30.56 18.49z"
})), /*#__PURE__*/React.createElement("mask", {
  id: "a95e996f-f07a-4d9e-a559-59990c3b802f",
  x: 105.63,
  y: 64.75,
  width: 33.73,
  height: 29.27,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  className: "e9f6f297-f1df-4f88-9e9d-e5bc97273b66",
  d: "M106.2 85.39a17.87 17.87 0 1030.58-18.49c-5.1-8.44-35.68 10.1-30.58 18.49z"
})), /*#__PURE__*/React.createElement("style", null, ".e9f6f297-f1df-4f88-9e9d-e5bc97273b66{fill:#fff}.b43600d7-344e-4e3b-8572-14912beb086d{fill:#ab7ca0}.a822a860-1bbd-4c98-b4fb-35eff8d3e389{fill:none;stroke-miterlimit:10;stroke:#ab7ca0;stroke-width:9.37px}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "b43600d7-344e-4e3b-8572-14912beb086d",
  d: "M106.06.05A9.18 9.18 0 0099.4 2a4 4 0 01-5 0A9.15 9.15 0 0087.7.05a9.23 9.23 0 001 18.42 9.14 9.14 0 005.84-2.09 3.79 3.79 0 014.78 0 9.23 9.23 0 0015-8.2 9.26 9.26 0 00-8.26-8.13z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "a822a860-1bbd-4c98-b4fb-35eff8d3e389",
  d: "M96.88 35.49V9.24"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "b43600d7-344e-4e3b-8572-14912beb086d",
  d: "M106.06 175.34a9.22 9.22 0 00-6.66 1.94 4 4 0 01-5 0 9.24 9.24 0 10.13 14.39 3.79 3.79 0 014.78 0 9.22 9.22 0 0015-8.19 9.27 9.27 0 00-8.25-8.14z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "a822a860-1bbd-4c98-b4fb-35eff8d3e389",
  d: "M96.88 158.27v26.26"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "b43600d7-344e-4e3b-8572-14912beb086d",
  d: "M191.78 94.36a9.24 9.24 0 10-14.39.13 3.9 3.9 0 01-.11 4.91 9.24 9.24 0 1014.39-.13 3.9 3.9 0 01.11-4.91z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "a822a860-1bbd-4c98-b4fb-35eff8d3e389",
  d: "M158.27 96.88h26.26"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "b43600d7-344e-4e3b-8572-14912beb086d",
  d: "M16.48 94.36a9.1 9.1 0 001.94-6.66A9.23 9.23 0 000 88.65a9.14 9.14 0 002.09 5.84A3.91 3.91 0 012 99.4a9.23 9.23 0 1016.48 5.72 9.17 9.17 0 00-2.09-5.85 3.91 3.91 0 01.09-4.91z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "a822a860-1bbd-4c98-b4fb-35eff8d3e389",
  d: "M35.49 96.88H9.24"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "b43600d7-344e-4e3b-8572-14912beb086d",
  d: "M171.85 34.9a9.25 9.25 0 00-6.09-3.34A4 4 0 01162.2 28a9.17 9.17 0 00-3.33-6.08 9.23 9.23 0 00-12.36 13.69 9.14 9.14 0 005.56 2.65 3.86 3.86 0 013.43 3.44 9.23 9.23 0 0016.42 4.77 9.28 9.28 0 00-.07-11.57z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "a822a860-1bbd-4c98-b4fb-35eff8d3e389",
  d: "M140.29 53.47l18.57-18.56"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "b43600d7-344e-4e3b-8572-14912beb086d",
  d: "M47.89 158.85a9.2 9.2 0 00-6.08-3.34 4 4 0 01-3.56-3.51 9.17 9.17 0 00-3.34-6.08 9.24 9.24 0 10-6.8 16.35 3.84 3.84 0 013.44 3.43 9.14 9.14 0 002.65 5.56 9.23 9.23 0 0013.69-12.36z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "a822a860-1bbd-4c98-b4fb-35eff8d3e389",
  d: "M53.47 140.29l-18.56 18.57"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "b43600d7-344e-4e3b-8572-14912beb086d",
  d: "M170.42 145.8a9.23 9.23 0 00-14.91 6.2 4 4 0 01-3.56 3.56 9.24 9.24 0 1010.27 10.14 3.83 3.83 0 013.43-3.43 9.23 9.23 0 004.77-16.42z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "a822a860-1bbd-4c98-b4fb-35eff8d3e389",
  d: "M140.29 140.29l18.57 18.57"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  className: "b43600d7-344e-4e3b-8572-14912beb086d",
  d: "M46.47 21.85A9.23 9.23 0 0031.56 28 4 4 0 0128 31.56 9.24 9.24 0 1038.26 41.7a3.87 3.87 0 013.44-3.44 9.23 9.23 0 004.77-16.41z"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  className: "a822a860-1bbd-4c98-b4fb-35eff8d3e389",
  d: "M53.47 53.47L34.91 34.91"
});

var _ref19 = /*#__PURE__*/React.createElement("circle", {
  cx: 97.51,
  cy: 96.88,
  r: 66.77,
  fill: "#8c6382"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  className: "e9f6f297-f1df-4f88-9e9d-e5bc97273b66",
  d: "M87.56 85.39A17.87 17.87 0 1157 66.9c5.09-8.44 35.67 10.1 30.56 18.49z"
});

var _ref21 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#a9920bde-2c0e-4686-88a5-5d3c54e18443)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 78.33,
  cy: 82.84,
  r: 5.86
}));

var _ref22 = /*#__PURE__*/React.createElement("path", {
  className: "e9f6f297-f1df-4f88-9e9d-e5bc97273b66",
  d: "M106.2 85.39a17.87 17.87 0 1030.58-18.49c-5.1-8.44-35.68 10.1-30.58 18.49z"
});

var _ref23 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#a95e996f-f07a-4d9e-a559-59990c3b802f)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 115.44,
  cy: 82.84,
  r: 5.86
}));

var _ref24 = /*#__PURE__*/React.createElement("path", {
  className: "e9f6f297-f1df-4f88-9e9d-e5bc97273b66",
  d: "M134.15 119.31c-2.66 2-10.41 4.22-13.28 2S118.6 111.09 120 108M116 106.16c-1.48 3-7.25 8.51-10.66 7.8s-6.22-8.21-6.28-11.55M94.72 102.41c-.06 3.34-2.88 10.76-6.28 11.55s-9.18-4.8-10.66-7.8M73.8 108c1.36 3 1.93 11-.9 13.28s-10.63 0-13.29-2"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M135.64 119.84a50.25 50.25 0 00-77.52 0",
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: "3.8px",
  fill: "none",
  strokeMiterlimit: 10
});

function SvgVirus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bd5e66a7-e4b8-4b40-9a63-f90811126833",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 193.77 193.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirus);
export default __webpack_public_path__ + "static/media/virus.65b3aeda.svg";
export { ForwardRef as ReactComponent };